import { render, staticRenderFns } from "./StockKlineWithPopular.vue?vue&type=template&id=2b634321"
import script from "./StockKlineWithPopular.vue?vue&type=script&lang=js"
export * from "./StockKlineWithPopular.vue?vue&type=script&lang=js"
import style0 from "./StockKlineWithPopular.vue?vue&type=style&index=0&id=2b634321&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports